import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: absolute;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: left;
  flex-shrink: 0;
  border: none;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  padding: 0 ${({ theme }) => theme.space["space-4"]};
  border-right: 1px solid ${({ theme }) => theme.colorTokens.border.default};

  &:active {
    background-color: ${({ theme }) =>
      theme.colorTokens.component.button.buttonLink.background.hover};
  }
`;

export const BackTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${({ theme }) => theme.space["space-4"]};
`;
